import React from "react"; 
import 'animate.css/animate.min.css'; // Import animate.css for animations
import { useEffect } from "react";
import u from '../assets/images/unsplash_LJ9KY8pIH3E.png'
export default function About(){
    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('wow', 'fadeInUp');
            }
          });
        });
    
        document.querySelectorAll('.wow-delayed').forEach(element => {
          observer.observe(element);
        });
      }, []);
    
    return(
        <>
              </>
    )
}